import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=2261084e"
import script from "./resource.vue?vue&type=script&lang=js"
export * from "./resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2261084e')) {
      api.createRecord('2261084e', component.options)
    } else {
      api.reload('2261084e', component.options)
    }
    module.hot.accept("./resource.vue?vue&type=template&id=2261084e", function () {
      api.rerender('2261084e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DynamicOption/resource.vue"
export default component.exports